const UPDATE_REVIEWS = 'update_reviews';
const UPDATE_BREAKDOWN_SELECTED = 'update_breakdown_selected';
const UPDATE_THUMBS_SELECTED = 'update_thumbs_selected';
const UPDATE_FILTER_SELECTED = 'update_filter_selected';
const UPDATE_WORK_SAMPLE_SELECTED = 'update_work_sample_selected';
const UPDATE_INDUSTRY_DROPDOWN_SELECTION = 'update_industry_selection';
const UPDATE_HELPFUL_COUNT = 'update_helpful_count';
const UPDATE_BUSINESS_SELECTED = 'update_business_selected';
const CLEAR_ALL_FILTERS = 'clear_all_filters';

module.exports = {
    UPDATE_REVIEWS,
    UPDATE_BREAKDOWN_SELECTED,
    UPDATE_THUMBS_SELECTED,
    UPDATE_FILTER_SELECTED,
    UPDATE_WORK_SAMPLE_SELECTED,
    UPDATE_INDUSTRY_DROPDOWN_SELECTION,
    UPDATE_HELPFUL_COUNT,
    UPDATE_BUSINESS_SELECTED,
    CLEAR_ALL_FILTERS,
};
